import React, { forwardRef, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";

import { ISelect } from "./select.d.ts";
import { Container, Label } from "./styles";
import { isEmpty } from "../../../utils/index.js";
import Errormessage from "../ErrorMessage/index.jsx";

/**
 * Componente de Select
 * @param {ISelect} props - Props do componente
 * @returns {JSX.Element} Componente do Select
 **/

const Select = forwardRef(
	/**
	 * Componente de Select
	 * @param {ISelect} props - Props do componente
	 * @returns {JSX.Element} Componente do Select
	 **/
	({ defaultValue, error, label, options, placeholder, showError, isRequired = false, onChange }, ref) => {
		const [hasError, setHasError] = useState(false);
		const [selectedForUser, setSelectedForUser] = useState(null);
		const [isDropdownOpen, setIsDropdownOpen] = useState(false);

		useEffect(() => {
			setHasError(!isEmpty(error));
		}, [error]);

		useEffect(() => {
			if (!defaultValue) return;

			setSelectedForUser(defaultValue);
		}, []);

		const selecting = (value) => {
			const selected = options.find((item) => item.label.toUpperCase() === value.toUpperCase());
			setSelectedForUser(selected);

			if (onChange) {
				onChange(selected);
			}
		};

		return (
			<Container error={Boolean(hasError)} className="container-react-select">
				{label?.length && (
					<Label htmlFor="input-form" required={isRequired}>
						{label}
					</Label>
				)}
				<Dropdown
					id="input-form"
					drop="down"
					show={isDropdownOpen}
					onToggle={() => setIsDropdownOpen(!isDropdownOpen)}
				>
					<Dropdown.Toggle
						className="select"
						id="dropdown-custom-components"
						variant="link"
					>
						{(selectedForUser && selectedForUser.label) ?? placeholder}
					</Dropdown.Toggle>
					<Dropdown.Menu ref={ref}>
						{options.map((item) => (
							<Dropdown.Item
								key={item.value}
								onClick={(event) => {
									event.stopPropagation();
									setIsDropdownOpen(
										!isDropdownOpen
									);
									selecting(event.target.text);
								}}
							>
								{item.label}
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown>

				{showError && hasError && <Errormessage message={error?.message} />}
			</Container>
		);
	}
);

Select.displayName = "Select";

export default Select;
